import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

@Component({
  selector: 'page-user-edit',
  templateUrl: 'user-edit.html'
})
export class UserEditPage {

  blockBack: any;
  event: any;

  constructor(public navCtrl: NavController, public params: NavParams) {
    this.blockBack = this.params.get('blockBack');
    this.event = this.params.get('event');
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/user-edit/user-edit.ts